// extracted by mini-css-extract-plugin
module.exports = {"container":"cards_container__20HSP","card":"cards_card__3UreD","infected":"cards_infected__2GxDy","recovered":"cards_recovered__2z1Yh","deaths":"cards_deaths__2WjQc"};